import { buttonVariants } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog'
import { DownloadIcon, XIcon } from 'lucide-react'

import { auxApi } from '@/axios'

export function ImageNodeModal({
  open,
  setOpen,
  imageUrl,
}: {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  imageUrl: string
}) {
  const downloadUrl = auxApi.getUri({
    url: '/download-redirect',
    params: { url: imageUrl },
  })

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
    >
      <DialogContent
        showCloseButton={false}
        className="w-full h-full sm:max-w-full p-0 ring-0 bg-transparent shadow-none pointer-events-none"
      >
        <DialogTitle className="sr-only">Image Lightbox</DialogTitle>

        <div className="absolute right-6 top-6 flex items-center gap-2 pointer-events-auto">
          <a
            href={downloadUrl}
            target="_blank"
            rel="noreferrer"
            aria-label="Download image"
            className={buttonVariants({
              variant: 'secondary',
              size: 'icon-lg',
            })}
          >
            <DownloadIcon />
          </a>

          <DialogClose
            aria-label="Close"
            className={buttonVariants({
              variant: 'secondary',
              size: 'icon-lg',
            })}
          >
            <XIcon />
          </DialogClose>
        </div>

        <img
          src={imageUrl}
          alt="Full resolution image"
          draggable={false}
          className="bg-black/50 max-h-[85vh] max-w-[85vw] m-auto rounded object-contain shadow-xl pointer-events-auto"
        />
      </DialogContent>
    </Dialog>
  )
}
